import { createContext, useContext } from 'react'
import { DEFAULT_DAY_CUTOFF_HOUR } from '@shared/dayCutoff'

// The event's day cutoff (`eventDayCutoff()`) for everything under an event's
// schedule or festival mode — the grid, the now-line, and every "is it on now"
// read anchor post-midnight set times with it.
export const DayCutoffContext = createContext<number>(DEFAULT_DAY_CUTOFF_HOUR)

export function useDayCutoff(): number {
  return useContext(DayCutoffContext)
}
